import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import { encryptPassword } from "./Encrypt"; 

import { setCookie, getCookie, eraseCookie } from "./cookieUtils";
import { Eye, EyeOff } from "lucide-react";

const ClientLogin = ({ onLoginSuccess }) => {
    const inputrefs = useRef([]);
    const navigate = useNavigate();
    const [login, setLogin] = useState({
        userCode: "",
        password: ""
    });
    const [showWelcomeDiv, setShowWelcomeDiv] = useState(false);
    const [userName, setUserName] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    // Check session on mount
    useEffect(() => {
        const token = getCookie("loginToken");
        const name = getCookie("userName");

        if (token === "Login Success") {
            setShowWelcomeDiv(true);
            setUserName(name || "Admin");
        }
        //inputrefs.current["txtUserName"].focus();
    }, []);

    const handleLogin = async () => {
        try {
            //const encryptedPassword = encryptPassword(login.password);

            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/UserLogin/Login`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    AuthToken: "NASSKD28462RWKF35793FWEU757",
                    LoginUserCode: login.userCode,
                    UserCode: login.userCode,
                    Password: login.password
                }),
            });

            const data = await res.json();

            if (data.status === "SUCCESS") {
                setCookie("loginToken", data.loginToken);
                setCookie("userName", data.userName);
                setCookie("accessType", data.accessType);
                setCookie("userCode", login.userCode);

                setUserName(data.userName);

                if (data.loginToken === "Login Success") {
                    setShowWelcomeDiv(true);
                    toast.success("Login successful!");
                    navigate("/ClientLogin");
                } else {
                    setShowWelcomeDiv(false);
                    toast.error("Invalid login token");
                }

                if (onLoginSuccess && typeof onLoginSuccess === 'function') {
                    onLoginSuccess({
                        loginToken: data.loginToken,
                        userName: data.userName,
                        accessType: data.accessType
                    });
                }
            } else {
                toast.error(data.message);
                const focusField = data?.focus || data?.Focus;
                if (focusField && inputrefs.current[focusField]) {
                    inputrefs.current[focusField].focus();
                }
            }
        } catch (err) {
            console.error(err);
            toast.error("Login failed. Please try again.");
        }
    };

    const handleLogout = async () => {
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/UserLogin/Logout`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    AuthToken: "NASSKD28462RWKF35793FWEU757",
                    LoginUserCode: getCookie("userCode")
                }),
            });

            const data = await res.json();

            if (data.status === "SUCCESS") {
                eraseCookie("loginToken");
                eraseCookie("userName");
                eraseCookie("accessType");
                eraseCookie("userCode");
                toast.success(data.message);
                navigate("/"); 
            } else {
                toast.error(data.message || "Logout failed");
            }

        } catch (err) {
            console.error(err);
            toast.error("Logout API error");
        }
    };

    return (
        <>
{!showWelcomeDiv ? (
                // Login Form
                <div className="sidebar-card">
                    <div className="sidebar-card-header login-card-header">
                        <i className="fa fa-user-circle"></i> Client Login
                    </div>
                    <div className="sidebar-card-body">
                        <div className="login-field">
                            <label>Username</label>
                            <input
                                id="txtUserName"
                                type="text"
                                ref={(el) => (inputrefs.current["txtUserName"] = el)}
                                value={login.userCode}
                                onChange={(e) => setLogin({ ...login, userCode: e.target.value })}
                                className="track-input"
                                placeholder="Enter username"
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        inputrefs.current["txtPassword"]?.focus();
                                    }
                                }}
                            />
                        </div>
                        <div className="login-field mb-3 position-relative">
                            <label>Password</label>
                            <div className="position-relative">
                                <input
                                    id="txtPassword"
                                    type={showPassword ? "text" : "password"}
                                    ref={(el) => (inputrefs.current["txtPassword"] = el)}
                                    value={login.password}
                                    onChange={(e) => setLogin({ ...login, password: e.target.value })}
                                    className="track-input m-0"
                                    style={{ paddingRight: "40px" }}
                                    placeholder="••••••••"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            inputrefs.current["btnSub"]?.focus();
                                        }
                                    }}
                                />
                                <span
                                    className="position-absolute cursor-pointer"
                                    style={{ right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", color: "#6b7c99" }}
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </span>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between align-items-center mb-3 mt-2">
                            <label style={{ fontSize: "12px", cursor: "pointer" }}>
                                <input type="checkbox" className="me-1" /> Remember me
                            </label>
                            <a href="#" style={{ fontSize: "12px", color: "red", textDecoration: "none" }}>
                                Forgot?
                            </a>
                        </div>
                        <button className="login-btn" onClick={handleLogin} id="btnSub" ref={(el) => (inputrefs.current["btnSub"] = el)} >
                            <i className="fa fa-sign-in-alt me-1"></i> Login
                        </button>
                    </div>
                </div>
            ) : (
                // Welcome Div with Links
                <div className="sidebar-card rounded">
                        <div className="card-header login-card-header bg-light d-flex justify-content-between align-items-center px-3 py-2 border-bottom rounded-top">

                            {/* Left side */}
                            <div className="d-flex align-items-center gap-2 text-white">
                                <i className="fa fa-user-circle text-primary fs-5"></i>
                                <span className="fw-semibold">
                                    Welcome! {userName}
                                </span>
                            </div>

                            {/* Right side button */}
                            <button
                                onClick={handleLogout}
                                className="btn btn-sm btn-danger d-flex align-items-center gap-1"
                            >
                                <i className="fa fa-sign-out-alt"></i>
                                Logout
                            </button>

                        </div>

                    <div style={{ padding: "10px 0" }}>
                            <Link to="/PickupReport" className="nav-link" style={{ display: 'block', padding: '12px', textDecoration: 'none', color: '#333', borderBottom: '1px solid #eee' }}>
                            <i className="ti ti-clipboard-list"></i> Pickup Report
                        </Link>
                            <Link to="/PickupStatusReport" className="nav-link" style={{ display: 'block', padding: '12px', textDecoration: 'none', color: '#333', borderBottom: '1px solid #eee' }}>
                            <i className="ti ti-package"></i> Packet Status Report
                        </Link>
                        <Link to="/ChangePassword" className="nav-link" style={{ display: 'block', padding: '12px', textDecoration: 'none', color: '#333', borderBottom: '1px solid #eee' }}>
                            <i className="ti ti-lock"></i> Change Password
                        </Link>
                        <Link to="/ClientLogin" className="nav-link" style={{ display: 'block', padding: '12px', textDecoration: 'none', color: '#333', borderBottom: '1px solid #eee' }}>
                            <i className="ti ti-user-plus"></i> Create Client Login
                        </Link>
                            <Link to="/CreateContactDetails" className="nav-link" style={{ display: 'block', padding: '12px', textDecoration: 'none', color: '#333', borderBottom: '1px solid #eee' }}>
                            <i className="ti ti-address-book"></i> Create Contacts Detail
                        </Link>
                            <Link to="/PODUpload" className="nav-link" style={{ display: 'block', padding: '12px', textDecoration: 'none', color: '#333' }}>
                            <i className="ti ti-upload"></i> Upload POD
                        </Link>
                    </div>
                </div>
            )}
        </>
    );
};

export default ClientLogin;
